"use strict";

module.exports = {
  EMAIL: 'EMAIL',
  TODO: 'TODO'
};